import React from 'react';
import { Loader } from '../common/Loader';
import { InvitationForm } from './InvitationForm';
import { SearchUser } from './SearchUser';
import { SearchUserContext } from './SearchUserContext';
import { useGetManagedUsers } from './useGetManagedUsers';
import UserTable from './UserTable';

export const UserManagement = () => {
  const { data: users = [], isLoading } = useGetManagedUsers();
  return (
    <div>
      <div className='deprecation_message'>
        <p>
          <b>Migration Alert:</b> As communicated via email on June 27, our Enscape product will
          soon begin using our Chaos licensing system. To complete the migration process, please
          note that the user management feature will be temporarily disabled from July 29 until July
          31. All users will continue to access their licenses as usual during this period. The user
          management feature will resume on August 1 at{' '}
          <a href='https://my.chaos.com'>my.chaos.com</a>.
        </p>
      </div>
      <InvitationForm />
      {isLoading ? (
        <Loader />
      ) : (
        <>
          <SearchUserContext users={users}>
            <SearchUser />
            <UserTable />
          </SearchUserContext>
        </>
      )}
    </div>
  );
};
